import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

const CustomerProtectedRoute = ({ children }) => {
  const { customer, loading } = useCustomerAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!customer) {
    return <Navigate to="/customer-auth" replace />;
  }

  return children;
};

export default CustomerProtectedRoute;
